<tt-page>
    <tt-page-heading> {{ heading }}</tt-page-heading>
    <tt-select-line-model class="col-xs-12 col-md-4 p-5" [params]="params" (getLoaded)="setHeading($event)" (submit)="onSubmit($event)"></tt-select-line-model>
</tt-page>
